import * as React from '@wordpress/element';
import { createHigherOrderComponent } from '@wordpress/compose';
import { PanelBody } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { useEntriesBlock } from '../../hooks';
import ConditionalLogicControl from './sidebar/ConditionalLogicControl/ConditionalLogicControl';

const ConditionalLogicPanel = createHigherOrderComponent((BlockEdit) => {
	return (props) => {
		// Only show the panel if the block is a descendant of the Entries block.
		const entriesBlock = useEntriesBlock();
		const isGPEBBlock = props.name.startsWith('gp-entry-blocks/');

		if (!entriesBlock) {
			return <BlockEdit {...props} />;
		}

		// Show the Conditional Logic panel for an allowed list of GPEB blocks.
		if (isGPEBBlock) {
			const allowedGPEBBlocksWithConditionalLogic = [
				'gp-entry-blocks/edit-form',
			];

			if (!allowedGPEBBlocksWithConditionalLogic.includes(props.name)) {
				return <BlockEdit {...props} />;
			}
		}

		return (
			<>
				<BlockEdit key="edit" {...props} />
				<InspectorControls>
					<PanelBody
						title={__(
							'Entry Blocks Conditional Logic',
							'gp-entry-blocks'
						)}
					>
						<ConditionalLogicControl {...props} />
					</PanelBody>
				</InspectorControls>
			</>
		);
	};
}, 'ConditionalLogicPanel');

export default ConditionalLogicPanel;
